;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { Step } from "react-joyride";
import { scrollTourTargetIntoViewWhenReady } from "@/features/onboarding-tours/orchestrator/scroll-tour-target";
import { runTourStepEffect } from "@/features/onboarding-tours/orchestrator/tour-step-actions";
import type { TourStepData } from "@/features/onboarding-tours/types/tour-definition";

function getStepData({ step }: { step: Step | undefined }): TourStepData {
	return (step?.data ?? {}) as TourStepData;
}

export async function runTourStepPrep({
	step,
	signal,
}: {
	step: Step | undefined;
	signal?: AbortSignal;
}): Promise<void> {
	const stepData = getStepData({ step });

	if (stepData.tourStepEffect) {
		runTourStepEffect({ effect: stepData.tourStepEffect });
	}

	if (signal?.aborted) {
		return;
	}

	if (stepData.tourScrollBefore) {
		await scrollTourTargetIntoViewWhenReady({
			signal,
			target: stepData.tourScrollBefore,
		});
	}
}
